<div class="spinner-container" *ngIf="loadingService.loading$ | async">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
